import { PaymentPlanInstalment } from '@client/PaymentPlanInstalment'
import TableEntity from '@ui/TableEntity'

export class PaymentPlan implements TableEntity {
	constructor(
		public id: number,
		public currency: string,
		public service: string,
		public service_id: string,
		public total_amount: number,
		public instalments: PaymentPlanInstalment[],
	) {}
}
